import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Button, Text, View } from 'src/components/common';

export type okModalData = {
  title?: string;
  message?: string;
  okText?: string;
  onOk?: (...arg: any[]) => void;
};
const OkModal: React.FC<Props> = ({ modalData }) => {
  const { title, message, okText, onOk = () => {} } = modalData as okModalData;

  return (
    <View className={`ctn-modal__content`}>
      {title && <h2 className="mb-2">{title}</h2>}
      {message && <Text className="mb-5">{message}</Text>}
      <View isRow justify="center">
        <Button onClick={onOk}>{okText || 'OK'}</Button>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OkModal);
